import { gql } from '@apollo/client';

export const SAVED_PROPERTIES_QUERY = gql`
    query getSavedProperties {
        savedProperties {
            id
            recordId
            expiresAt
            manager {
                recordId
                status
            }
        }
    }
`;

export const EDIT_PROPERTY_EVENTS = gql`
    mutation EditPropertyEvents($id: ID!, $events: [String]) {
        updateProperty(id: $id, events: $events) {
            id
            events {
                id
                recordId
                code
            }
        }
    }
`;

export const EDIT_PROPERTY_CONTACTS = gql`
    mutation EditPropertyContacts($id: ID!, $contacts: [ID]) {
        updateProperty(id: $id, contacts: $contacts) {
            id
            contacts {
                id
                recordId
                prefix
                lastName
                firstName
                middleName
                lastName
                suffix
                title
                photoUrl
                company {
                    id
                    recordId
                    name
                    addresses {
                        city
                        stateProvince
                        preferredMailing
                    }
                    primaryBusinessType {
                        name
                    }
                }
                address {
                    city
                    stateProvince
                }
            }
        }
    }
`;

export const ADD_VIEWER_AS_PROPERTY_CONTACT = gql`
    mutation AddViewerToProperty($id: ID!) {
        addViewerToProperty(id: $id) {
            id
        }
    }
`;

export const REMOVE_VIEWER_FROM_PROPERTY_CONTACTS = gql`
    mutation RemoveViewerFromProperty($id: ID!) {
        removeViewerFromProperty(id: $id) {
            id
        }
    }
`;

export const REMOVE_PROPERTY = gql`
    mutation RemoveProperty($id: ID!) {
        removeProperty(id: $id) {
            id
        }
    }
`;

export const FAVORITE_PROPERTY = gql`
    mutation FavoriteProperty($recordId: Int!) {
        saveProperty(recordId: $recordId) {
            property {
                id
                recordId
            }
        }
    }
`;

export const UNFAVORITE_PROPERTY = gql`
    mutation UnfavoriteProperty($recordId: Int!) {
        removeSavedProperty(recordId: $recordId) {
            property {
                id
                recordId
            }
        }
    }
`;

export const ADD_PROPERTY_PHOTO = gql`
    mutation AddPropertyPhoto($propertyId: ID!, $isCoverPhoto: Boolean) {
        addPropertyPhoto(propertyId: $propertyId, isCoverPhoto: $isCoverPhoto) {
            id
            recordId
            isCoverPhoto
            url
            uploadUrl
        }
    }
`;

export const REMOVE_PROPERTY_PHOTO = gql`
    mutation RemovePropertyPhoto($id: ID!) {
        removePropertyPhoto(id: $id) {
            id
        }
    }
`;

export const ADD_PROPERTY_SITE_PLAN = gql`
    mutation AddPropertySitePlan($propertyId: ID!) {
        addPropertySitePlan(propertyId: $propertyId) {
            id
            recordId
            url
            uploadUrl
        }
    }
`;

export const REMOVE_PROPERTY_SITE_PLAN = gql`
    mutation RemovePropertySitePlan($propertyId: ID!) {
        removeSitePlan(propertyId: $propertyId) {
            id
        }
    }
`;

export const ADD_PROPERTY_VIEW = gql`
    mutation AddPropertyView($id: ID!) {
        addPropertyView(id: $id) {
            viewer {
                recordId
            }
        }
    }
`;

export const GET_PROPERTY_VIEWS = gql`
    query GetPropertyViews($id: ID!) {
        propertyViews(id: $id) {
            createdAt
            viewer {
                recordId
                firstName
                lastName
                company {
                    recordId
                    name
                }
            }
        }
    }
`;
